import React from 'react';
import PropTypes from 'prop-types';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {Divider} from '@homeaway/react-collapse';

import './FaqNode.less';

export class FaqNodeBase extends React.Component {
    static propTypes = {
        dividerId: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    };

    render() {
        const {isMobile, text, title} = this.props;

        return (
            /* eslint-disable react/no-danger */
            <div className="confirmation-faqs__node">
                {!isMobile && (
                    <span>
                        <div>
                            <strong>{title}</strong>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: text}} />
                    </span>
                )}
                {isMobile && (
                    <span>
                        <Divider heading={title} id={this.props.dividerId}>
                            <div dangerouslySetInnerHTML={{__html: text}} />
                        </Divider>
                    </span>
                )}
            </div>
            /* eslint-enable react/no-danger */
        );
    }
}

const faqNode = determineIfMobile(FaqNodeBase);

export {faqNode as FaqNode};
